export default __webpack_public_path__ + "img/2ed960bb2d0c1fa2e7ce4a67f0ffc300.png";